import { DAG } from '@pollination-solutions/pollination-sdk'
import { DAGOutput } from 'src/types/queenbee/io'

export const flowInputByName = (flow: DAG, name: string): DAGOutput | undefined => {
  // @ts-ignore
  return flow.inputs?.filter((input) => input.name === name).pop()
}
